module.exports = __webpack_public_path__ + "static/media/bluepen.e48bb9ef.svg";